import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import ProfileVideo from "./profile-videos/profile-video";

export default function ProfileVideoUploadsTab({ onShowInfo }) {
  return (
    <div className="mt-4">
      <h2 className="font-medium mb-4 uppercase">
        Profile Videos{" "}
        <FontAwesomeIcon
          className="ml-2 cursor-pointer text-base"
          icon={faInfoCircle}
          onClick={onShowInfo}
        />
      </h2>
      <ProfileVideo />
    </div>
  );
}
